import { i18n } from '../../i18n/i18n.js'
import { LayerType } from '../../map/layerManager.js'

export class LayerControls {
  constructor(options = {}) {
    this.onToggle = options.onToggle || (() => {})
    this.element = null
    this.activeLayers = new Set([
      LayerType.NODES
    ])
  }

  render(container) {
    this.element = document.createElement('div')
    this.element.className = 'layer-controls'
    this.element.setAttribute('role', 'group')
    this.element.setAttribute('aria-label', i18n.t('common.layerToggle'))

    const layers = [
      { type: LayerType.REGIONS, label: i18n.t('layers.fiveElements'), icon: '🎯' },
      { type: LayerType.NODES, label: i18n.t('layers.dragonNodes'), icon: '🔴' },
      { type: LayerType.VEINS, label: i18n.t('layers.dragonVeins'), icon: '🐉' }
    ]

    this.element.innerHTML = layers
      .map(
        (layer) => `
      <button
        class="layer-btn ${this.activeLayers.has(layer.type) ? 'active' : ''}"
        data-layer="${layer.type}"
        aria-pressed="${this.activeLayers.has(layer.type)}"
        title="${layer.label}"
      >
        <span class="layer-icon">${layer.icon}</span>
        <span class="layer-label">${layer.label}</span>
      </button>
    `
      )
      .join('')

    this._bindEvents()
    container.appendChild(this.element)
  }

  _bindEvents() {
    this.element.addEventListener('click', (e) => {
      const btn = e.target.closest('.layer-btn')
      if (!btn) return

      const layerType = btn.dataset.layer
      const isActive = btn.classList.contains('active')

      if (isActive) {
        btn.classList.remove('active')
        btn.setAttribute('aria-pressed', 'false')
        this.activeLayers.delete(layerType)
        this.onToggle(layerType, false)
      } else {
        btn.classList.add('active')
        btn.setAttribute('aria-pressed', 'true')
        this.activeLayers.add(layerType)
        this.onToggle(layerType, true)
      }
    })
  }

  updateLanguage() {
    if (!this.element) return

    this.element.setAttribute('aria-label', i18n.t('common.layerToggle'))

    const labels = {
      [LayerType.REGIONS]: i18n.t('layers.fiveElements'),
      [LayerType.NODES]: i18n.t('layers.dragonNodes'),
      [LayerType.VEINS]: i18n.t('layers.dragonVeins')
    }

    const buttons = this.element.querySelectorAll('.layer-btn')
    buttons.forEach((btn) => {
      const layerType = btn.dataset.layer
      const label = labels[layerType] || ''
      const labelEl = btn.querySelector('.layer-label')
      if (labelEl) {
        labelEl.textContent = label
      }
      btn.setAttribute('title', label)
    })
  }

  setLayerVisibility(layerType, visible) {
    const btn = this.element.querySelector(`[data-layer="${layerType}"]`)
    if (!btn) return

    if (visible) {
      btn.classList.add('active')
      btn.setAttribute('aria-pressed', 'true')
      this.activeLayers.add(layerType)
    } else {
      btn.classList.remove('active')
      btn.setAttribute('aria-pressed', 'false')
      this.activeLayers.delete(layerType)
    }
  }

  destroy() {
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element)
    }
    this.element = null
  }
}
